import { I as t } from "../../iconLoader.gen-BvbXzKQt.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
//# sourceMappingURL=typeGuards.js.map
